import { authenticatedFetch } from "./apiClient";

const parseError = async (response, fallback) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || fallback);
  }
  return data;
};

export const fetchLibrarySnippets = async () => {
  const response = await authenticatedFetch("/snippets/all?source=library");
  return parseError(response, "Failed to fetch library snippets");
};

export const fetchPublicLibrarySnippets = async (language) => {
  const lang = encodeURIComponent(language || "en");
  const response = await authenticatedFetch(
    `/snippets/library/public?language=${lang}`,
    { skipAuth: true }
  );
  return parseError(response, "Failed to fetch library snippets");
};

export const fetchUserSnippets = async () => {
  const response = await authenticatedFetch("/snippets/all");
  return parseError(response, "Failed to fetch snippets");
};

export const addLibrarySnippet = async ({ text, specialty }) => {
  const response = await authenticatedFetch("/snippets/add", {
    method: "POST",
    body: JSON.stringify({
      snippet: {
        text,
        specialty: specialty || "General Medicine",
        source: "library",
        times_used: 0,
      },
    }),
  });
  return parseError(response, "Failed to add snippet");
};

export const addLibrarySnippetsBulk = async (
  text,
  specialty = "General Medicine"
) => {
  const response = await authenticatedFetch("/snippets/add_bulk", {
    method: "POST",
    body: JSON.stringify({
      text,
      snippet: {
        specialty: specialty || "General Medicine",
        source: "library",
        times_used: 0,
      },
    }),
  });
  return parseError(response, "Failed to add snippets");
};

export const addUserSnippet = async ({
  text,
  specialty = "general",
  source = "user",
  imported_from,
}) => {
  const response = await authenticatedFetch("/snippets/add", {
    method: "POST",
    body: JSON.stringify({
      snippet: {
        text,
        specialty,
        source,
        times_used: 0,
        ...(imported_from ? { imported_from } : {}),
      },
    }),
  });
  return parseError(response, "Failed to add snippet");
};

export const addUserSnippetsBulk = async (
  text,
  specialty = "general",
  imported_from
) => {
  const response = await authenticatedFetch("/snippets/add_bulk", {
    method: "POST",
    body: JSON.stringify({
      text,
      snippet: {
        specialty,
        source: "user",
        times_used: 0,
        imported_from: imported_from,
      },
    }),
  });
  return parseError(response, "Failed to add snippets");
};

export const updateLibrarySnippet = async (_id, snippet) => {
  const response = await authenticatedFetch("/snippets/update", {
    method: "PUT",
    body: JSON.stringify({
      _id,
      snippet: {
        ...snippet,
        source: "library",
      },
    }),
  });
  return parseError(response, "Failed to update snippet");
};

export const updateUserSnippet = async (_id, snippet) => {
  const response = await authenticatedFetch("/snippets/update", {
    method: "PUT",
    body: JSON.stringify({
      _id,
      snippet: {
        ...snippet,
        source: snippet.source || "user",
      },
    }),
  });
  return parseError(response, "Failed to update snippet");
};

export const deleteSnippet = async (_id) => {
  const response = await authenticatedFetch("/snippets/delete", {
    method: "DELETE",
    body: JSON.stringify({ _id }),
  });
  return parseError(response, "Failed to delete snippet");
};

export const deleteAllUserSnippets = async () => {
  const response = await authenticatedFetch("/snippets/delete_all", {
    method: "DELETE",
  });
  return parseError(response, "Failed to delete snippets");
};

export const deleteLibrarySnippet = deleteSnippet;

export const incrementSnippetUsage = async (_id) => {
  const response = await authenticatedFetch("/snippets/increment_usage", {
    method: "POST",
    body: JSON.stringify({ _id }),
  });
  return parseError(response, "Failed to increment snippet usage");
};
